export default __webpack_public_path__ + "static/media/top-b-5-med.dfdd4c53.jpg";